module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chno"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imgcrd"
  }, [_c('i', [_vm._v("Foliage")]), _vm._v(", by Lesley Riley, 7½˝ × 10˝")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One TAP is a single note.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Two TAPs are a beginning.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Three TAPs are a chord, the basis of harmony and the beginning of something wonderful to come.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Why the music lesson? Because this is my third book on TAP Transfer Artist Paper, and together the books create perfect harmony.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Thank you for picking up and opening this book. I have so much to share with you. The samples and projects on these pages are not only intended to demonstrate and educate but to inspire. I imagine you’re a lot like me—something in a book, magazine, or online will catch my eye, and the wheels of my imagination start turning with possibilities. I’ve made sure there is enough eye candy inside these pages to put your imagination and creative hands in gear.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("TAP Transfer Artist Paper is perfect for both art and craft applications. In this latest TAP book on creating with the newly formulated TAP paper, I will start by covering all of the basics of TAP transfers. Whether you are familiar with or new to TAP, you are in for a wonderful experience as you discover techniques and valuable tips and tricks, plus plenty of inspiration to get you going on transferring your photos and art onto a variety of surfaces.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("What the artist does is jump-start your mind and make you see something fresh, as if you were a visitor to the moon. "), _c('br')]), _vm._v("—John Baldessari")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imgcrd"
  }, [_c('i', [_vm._v("Winter Woods")]), _vm._v(", by Lesley Riley, 10½˝ × 13˝")]), _vm._v(" "), _c('div', {
    staticClass: "sbox"
  }, [_c('p', {
    staticClass: "sidhd"
  }, [_c('b', [_vm._v("What’s New About the New TAP")])]), _vm._v(" "), _c('p', {
    staticClass: "sidtxt"
  }, [_vm._v("If you have previously used TAP in the past, you will find that there are a few minor differences:")]), _vm._v(" "), _c('p', {
    staticClass: "bulls"
  }, [_c('span', {
    staticClass: "bbi"
  }, [_vm._v("•")]), _vm._v(" The polymer coating on the paper is thinner and smoother.")]), _vm._v(" "), _c('p', {
    staticClass: "bulls"
  }, [_c('span', {
    staticClass: "bbi"
  }, [_vm._v("•")]), _vm._v(" TAP paper is more translucent, which can aid in positioning.")]), _vm._v(" "), _c('p', {
    staticClass: "bulls"
  }, [_c('span', {
    staticClass: "bbi"
  }, [_vm._v("•")]), _vm._v(" TAP can be peeled hot or cold.")]), _vm._v(" "), _c('p', {
    staticClass: "bulls"
  }, [_c('span', {
    staticClass: "bbi"
  }, [_vm._v("•")]), _vm._v(" You cannot iron directly over a transferred image.")]), _vm._v(" "), _c('p', {
    staticClass: "bulls"
  }, [_c('span', {
    staticClass: "bbi"
  }, [_vm._v("•")]), _vm._v(" The coated surface does not scratch or crumble.")]), _vm._v(" "), _c('p', {
    staticClass: "bulls"
  }, [_c('span', {
    staticClass: "bbi"
  }, [_vm._v("•")]), _vm._v(" Shelf life is indefinite if stored in the original packaging and away from moisture.")])]), _vm._v(" "), _c('p', {
    staticClass: "hd1"
  }, [_vm._v("Getting Started Is Easy—What You Need")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bcol"
  }, [_vm._v("•")]), _vm._v(" TAP Transfer Artist Paper (by C&T Publishing)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bcol"
  }, [_vm._v("•")]), _vm._v(" Computer and inkjet printer")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bcol"
  }, [_vm._v("•")]), _vm._v(" Iron and firm ironing surface")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bcol"
  }, [_vm._v("•")]), _vm._v(" Surface to transfer onto (This book is full of examples.)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bcol"
  }, [_vm._v("•")]), _vm._v(" An idea")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("And then you just print, press, and peel. Shall we begin?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe3be276","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_introduction.vue
// module id = 69
// module chunks = 0